const Constantes = window.config.Constantes;

class Configurations{
  constructor() {
    this.defaultSitioId = Constantes.defaultSitioId;
    this.apiVersion = Constantes.apiVersion;
    this.cookieExpirationTime = Constantes.TimeExpiration;
    this.keyPressLimit = Constantes.keyPressLimit;
    this.freezeTime = Constantes.freezeTime;
    this.returnBackInterval = Constantes.returnBackInterval;
    this.dominioCookie = Constantes.dominioCookie || 'localhost';


    this.disableValidations = Constantes.disableValidations;
    this.enableQuickView = Constantes.enableQuickView;
    this.forceCreateNewAddress = Constantes.forceCreateNewAddress;
    this.elmahLevel = Constantes.elmahLevel;

    // =================================================
    // Dominios
    // =================================================
    this.apiLoginUrl = Constantes.Dominios.apiLogin;
    this.apiPaywallUrl = Constantes.Dominios.apiPaywall;
    this.urlStatic = Constantes.Dominios.static;
    this.defaultRedirectUrl = Constantes.Dominios.lanacion;
    this.urlImages = Constantes.Dominios.static + "/images";
    this.dominioMiCuenta = Constantes.Dominios.micuenta;
    this.dominioLaNacion = Constantes.Dominios.lanacion;
    this.urlPassport = Constantes.Dominios.passport;
    this.urlMiClub = Constantes.Dominios.miclub;
    this.urlBucket = Constantes.Dominios.bucket + '/Club.LN/anexos/fotos/productos/';
    // =================================================
    // Api Keys
    // =================================================
    this.wCentrixTime = Constantes.wCentrixTime;
    this.idWcentrix = Constantes.idWcentrix;
    this.fbId = Constantes.fbId;
    this.gmId = Constantes.gmId;
    this.gmRedirect = Constantes.gmRedirect;
    this.rcId = Constantes.rcId;
    this.gaId = Constantes.gaId;
    this.gtmId = Constantes.gtmId;
    this.SentryPaywall = Constantes.sentry_paywall || null;
    this.SentryIngresar = Constantes.sentry_ingresar || null;


    // ==================================================
    // Sitios Ids Asociar Tarjeta post-login
    // 6 - Club LN / 7 - Autogestión/MiClub
    // ==================================================  
    this.SitiosAsociarCredencial = Object.values(Constantes.SitiosAsociarCredencial);

    // ==================================================
    // Sitios Ids Permitidos
    // 1 - webLN / 2 - webCLL / 3 - webOH / 4 - appLN / 6 - Club LN / 7 - Autogestión/MiClub / 8 - Experiencias Black
    // ==================================================
    this.Sitios = Constantes.Sitios;

    // ==================================================
    // Dominios permitidos a redireccionar
    // ==================================================  
    this.dominiosPermitidos = RegExp(Constantes.dominiosPermitidos);

    // ========================================================
    // Diccionario de keys de usuario para grabar en cookies
    // ========================================================
    this.DiccionarioCookiesAGuardar = Object.values(Constantes.DiccionarioCookiesAGuardar);

    // =================================================
    // AB Testing
    // =================================================
    this.ABTesting = Constantes.ABTesting;
  }
}

//const Config = new Configurations();

export default Configurations;


// WEBPACK FOOTER //
// ./Statics/scripts/common/config.js